module.exports = __webpack_public_path__ + "static/media/github.53a20ba5.png";